"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShowQueryError = void 0;

var _react = _interopRequireDefault(require("react"));

var _useStatus2 = require("./useStatus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Shows an error toast message when a react-query fails
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useShowQueryError = function useShowQueryError(query, message) {
  var _useStatus = (0, _useStatus2.useStatus)(),
      showError = _useStatus.showError;

  var isError = query.isError;

  _react["default"].useEffect(function () {
    if (isError) {
      showError(message);
    }
  }, [isError, showError, message]);
};

exports.useShowQueryError = useShowQueryError;